export default {
  portalActivity: 'Portal activity',
  eventOne: '{count} event',
  eventOther: '{count} events',
  lastSignedIn: 'Last signed in {when}.',
  neverSignedIn: 'Never signed in.',
  activityEmptyTitle: 'Nothing recorded yet',
  activityEmptyMessage: 'Sign-ins and portal account changes will appear here.',
  colWhen: 'When',
  colWhat: 'What happened',
  colWho: 'Who',
  colArea: 'Area',
  colDetails: 'Details',
  system: 'System',
  history: 'History',
  changeOne: '{count} change',
  changeOther: '{count} changes',
  historyEmptyTitle: 'No changes recorded yet',
  historyEmptyMessage: "Edits to this employee's details, contacts and files will appear here.",
  hide: 'Hide',
  view: 'View',
  changeFromTo: '<from>{from}</from><sep> to </sep><to>{to}</to>',
  empty: 'empty',
  active: 'Active',
  inactive: 'Inactive',
  noJobTitle: 'No job title set',
  mobile: 'Mobile',
  copyEmail: 'Copy email',
  copyMobile: 'Copy mobile',
  primarySite: 'Primary site',
  employeeId: 'Employee ID',
  copyEmployeeId: 'Copy employee ID',
  inProbation: 'In probation, ends {date}',
  probationEnded: 'Probation ended {date}',
  noExpiry: 'No expiry',
  expiredOn: 'Expired {date}',
  expiresToday: 'Expires today',
  expiresInDays: 'Expires in {days}d',
  files: 'Files',
  documentOne: '{count} document',
  documentOther: '{count} documents',
  uploadFile: 'Upload file',
  filesAttentionOne: '{count} file is expired or expiring within 30 days.',
  filesAttentionOther: '{count} files are expired or expiring within 30 days.',
  filesEmptyTitle: 'No files yet',
  filesEmptyMessage: 'Keep licences, tickets, contracts and ID with the employee record. Only admins can see these.',
  colFile: 'File',
  colCategory: 'Category',
  colExpires: 'Expires',
  colAdded: 'Added',
  downloadFile: 'Download {name}',
  deleteFileTitle: 'Delete this file?',
  deleteFileMessage: '{name} will be permanently removed.',
  fileDeleted: 'File deleted.',
  chooseFile: 'Choose a file to upload.',
  fileUploaded: 'File uploaded.',
  uploadDescription: 'PDF, image, Word, Excel or text, up to 10 MB.',
  expiryDate: 'Expiry date',
  expiryDateHint: 'Optional. Flagged 30 days out.',
  uploading: 'Uploading…',
  upload: 'Upload',
  termResignation: 'Resignation',
  termDismissal: 'Dismissal',
  termRedundancy: 'Redundancy',
  termEndOfContract: 'End of contract',
  termRetirement: 'Retirement',
  termOther: 'Other',
  startOffboarding: 'Start offboarding',
  triggerChecklists: 'Trigger checklists',
  createTransferRequest: 'Create transfer request',
  offboardingStarted: 'Offboarding started.',
  offboardTitle: 'Offboard employee',
  offboardDescription: '{name} keeps access until the termination date, then is deactivated and their phone pairing is revoked.',
  heldAssetsOne: '<b>Warning:</b> {name} still has an asset assigned ({assets}). Collect it and mark it returned in Assets.',
  heldAssetsOther: '<b>Warning:</b> {name} still has {count} assets assigned ({assets}). Collect them and mark them returned in Assets.',
  terminationDate: 'Termination date',
  terminationType: 'Termination type',
  selectOption: 'Select an option',
  rehireQuestion: 'Would you consider this person for rehire? (optional)',
  noAnswer: 'No answer',
  unsure: 'Unsure',
  notesOptional: 'Notes (optional)',
  starting: 'Starting…',
  offboardingBanner: "Offboarding scheduled: last day <b>{date}</b> ({type}). They'll be deactivated automatically.",
  offboardingCancelled: 'Offboarding cancelled.',
  cancelOffboarding: 'Cancel offboarding',
  kindOnboarding: 'Onboarding',
  kindOffboarding: 'Offboarding',
  triggerOnboardingTitle: 'Trigger onboarding checklists',
  triggerOffboardingTitle: 'Trigger offboarding checklists',
  triggerDescription: 'These are sent to {name} as a task list on their profile.',
  checklistType: 'Checklist type',
  allChecklistsTriggered: 'All checklists that apply to this employee have already been triggered.',
  noChecklistsApply: 'No checklists apply to this employee.',
  taskOne: '{count} task',
  taskOther: '{count} tasks',
  checklistsBySite: 'Checklists apply by site. Change which ones apply in Checklist settings.',
  checklistsTriggered: 'Checklists triggered.',
  triggering: 'Triggering…',
  checklists: 'Checklists',
  checklistProgress: '{done} of {total} done',
  doneBy: 'Done by {email}',
  overdueOn: 'Overdue {date}',
  dueOn: 'Due {date}',
  transferCreated: 'Transfer request created.',
  transferDescription: "Move {name}'s primary site. The destination site's manager or an admin approves it.",
  transferTo: 'Transfer to',
  selectSite: 'Select a site',
  effectiveDate: 'Effective date',
  reasonOptional: 'Reason (optional)',
  creating: 'Creating…',
  createRequest: 'Create request',
  unknownSite: 'Unknown site',
  noSite: 'No site',
  transfers: 'Transfers',
  transfersEmptyTitle: 'No transfers',
  transfersEmptyMessage: 'Use Create transfer request to move this person to another site.',
  transferRoute: '{from} <sep>to</sep> <b>{to}</b>',
  transferFrom: 'from {date}',
  transferPending: 'Pending',
  transferApproved: 'Approved',
  transferApplied: 'Applied',
  transferRejected: 'Rejected',
  transferCancelled: 'Cancelled',
  transferApprovedToast: 'Transfer approved.',
  transferRejectedToast: 'Transfer rejected.',
  transferCancelledToast: 'Transfer cancelled.',
  approve: 'Approve',
  reject: 'Reject',
  notSet: 'Not set',
  employmentDetails: 'Employment details',
  employeeNumber: 'Employee number',
  jobTitle: 'Job title',
  employmentType: 'Employment type',
  contractType: 'Contract type',
  department: 'Department',
  primaryManager: 'Primary manager',
  startDate: 'Start date',
  probationEnds: 'Probation ends',
  noticePeriod: 'Notice period',
  noticeDays: '{count} days',
  recordCreated: 'Record created',
  phonePaired: 'Phone paired',
  notPaired: 'Not paired',
  appVersion: 'App version',
  lastHeardFromPhone: 'Last heard from phone',
  personalDetails: 'Personal details',
  fullName: 'Full name',
  dateOfBirth: 'Date of birth',
  homeAddress: 'Home address',
  contactPrimary: 'Primary',
  contactSecondary: 'Secondary',
  contactAdditional: 'Additional',
  emergencyContacts: 'Emergency contacts',
  addContact: 'Add contact',
  contactsEmptyTitle: 'No emergency contacts',
  contactsEmptyMessage: 'Add someone to call if there is an incident on site.',
  editName: 'Edit {name}',
  relationship: 'Relationship',
  daytimeNumber: 'Daytime number',
  afterHoursNumber: 'After hours number',
  afterHoursMobile: 'After hours mobile',
  address: 'Address',
  deleteContactTitle: 'Delete this contact?',
  deleteContactMessage: '{name} will be removed.',
  contactDeleted: 'Contact deleted.',
  contactUpdated: 'Contact updated.',
  contactAdded: 'Contact added.',
  editContactTitle: 'Edit emergency contact',
  newContactTitle: 'New emergency contact',
  contactType: 'Contact type',
  deleteName: 'Delete {name}',
}
